import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

export const clampPctInput = (n) =>
  Math.min(100, Math.max(0, Math.round(Number(n)) || 0));

/** Keeps native steppers visible at rest (not only on hover) — WebKit + Firefox. */
const numberSteppersVisibleSx = {
  '& input[type="number"]': {
    MozAppearance: 'number-input',
    textAlign: 'center',
  },
  '& input[type="number"]::-webkit-outer-spin-button': {
    WebkitAppearance: 'inner-spin-button',
    opacity: 1,
    display: 'block',
    height: '1.15em',
    marginTop: '0.1em',
    cursor: 'pointer',
  },
  '& input[type="number"]::-webkit-inner-spin-button': {
    WebkitAppearance: 'inner-spin-button',
    opacity: 1,
    display: 'block',
    height: '1.15em',
    cursor: 'pointer',
  },
};

/**
 * Small outlined % field — same markup as Budget allocation Shop/Field inputs.
 */
const PercentInputField = ({
  value,
  onChange,
  disabled = false,
  inputProps: inputPropsOverride,
  sx,
  ...rest
}) => (
  <TextField
    {...rest}
    value={value}
    onChange={onChange}
    type="number"
    size="small"
    disabled={disabled}
    inputProps={{
      min: 0,
      max: 100,
      style: { width: 56, textAlign: 'center' },
      ...inputPropsOverride,
    }}
    InputProps={{
      endAdornment: <InputAdornment position="end">%</InputAdornment>,
    }}
    sx={[numberSteppersVisibleSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  />
);

export default PercentInputField;
